import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, of, EMPTY } from 'rxjs';
import { catchError, delay, mergeMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { ErrorOverlayService } from 'src/app/shared/services/overlay.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private snackbarService: SnackbarService,
    private overlayService: ErrorOverlayService,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const skipErrorInterceptor = request.headers.has('skip-error-interceptor');

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (skipErrorInterceptor) {
          return throwError(() => error);
        }
        if (error) {
          switch (error.status) {
            case 400:
              this.snackbarService.openSnackBar({
                message: error.error.detail,
                type: 'error',
              });
              return of(null).pipe(
                delay(300),
                mergeMap(() => throwError(() => error)),
              );
            case 401:
              if (error.status === 401) {
                this.handleUnauthorizedError(error);
              }
              return EMPTY;
            case 500:
              this.snackbarService.openSnackBar({
                message: 'Something went wrong',
                type: 'error',
              });
              return of(null).pipe(
                delay(300),
                mergeMap(() => throwError(() => error)),
              );
            case 0:
              console.log('hereeeeeeeeeeeeeeee');
              this.snackbarService.openSnackBar({
                message: error.error.detail || 'Something went wrong',
                type: 'error',
              });
              return of(null).pipe(
                delay(300),
                mergeMap(() => throwError(() => error)),
              );
            case 404:
              this.snackbarService.openSnackBar({
                message: 'Something went wrong',
                type: 'error',
              });
              return EMPTY;
          }
        }
        return throwError(
          () => error.error.detail || error.message || 'Unknown error occurred',
        );
      }),
    );
  }

  getReadableResourceName(url: string): string {
    const match = url.match(/\/api\/([^/?]+)/);
    let rawResource = match?.[1] || 'resource';
    const formatted = rawResource
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return formatted;
  }

  handleUnauthorizedError(error: any) {
    const url = error?.url || '';
    const resource = this.getReadableResourceName(url);

    const message = `Contact System Admin User to grant "${resource}" permission.`;

    if (resource === 'Companies') {
      const message = `You currently do not have permission to access any features in this application.
Please contact your administrator to request the necessary access rights for your role.`;
      console.log('entered here');

      this.overlayService.showCompanyOverlay(message);
    } else {
      this.snackbarService.openSnackBar({
        message,
        type: 'error',
      });
    }
  }
}
